import apiClient from "@/services/api-client";
import { useQuery } from "@tanstack/react-query";

const getBlogListApi = async (queryString) => {
  return await apiClient({
    method: "get",
    url: `/v1/articles${queryString}`,
  });
};

export const useGetBlogList = (queryString, useQueryOptions) => {
  return useQuery({
    queryKey: ["blogs", queryString],
    queryFn: () => getBlogListApi(queryString),
    keepPreviousData: true,
    ...useQueryOptions,
    select: (res) => {
      return res.data?.data;
    },
  });
};
